import React from 'react'
import { NavLink } from 'react-router-dom'
import './Success.sass'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import Button from '../../ui/Button/Button'

function Success() {
  return (
    <div className="Success">
      <div className="DefaultContainer">
        <SectionTitle title="Оплата прошла успешно" />
        <p className="Success-Text">
          Спасибо! Платёж принят. Если у вас остались вопросы — свяжитесь с нами
          через форму на сайте.
        </p>
        <NavLink to="/" className="Success-Link">
          <Button title="На главную" theme="primary" size={48} />
        </NavLink>
      </div>
    </div>
  )
}

export default Success
